export { default as HorizontalCarouselItem } from './HorizontalCarouselItem';
export type { HorizontalCarouselItemProps } from './types';
